<template>
  <div class="flex text-center w-full flex-col px-4 py-4">
    <h3 class="text-xl">
      {{ $t('welcome.my_qr_code') }}
    </h3>
    <div v-if="accessLongToken" class="qr-code-wrap">
      <vue-qr class="my-4" v-bind="dafQrSettings" />
    </div>
    <div class="reminder-text">
      {{ $t('welcome.scan_qr_code_reminder') }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueQr from 'vue-qr';

export default {
  name: 'MyQrCode',
  components: {
    VueQr,
  },
  computed: {
    ...mapGetters('user', ['accessLongToken']),
    ...mapGetters('user', ['rmdSizes', 'tempAccess']),
    // Only for Esquel溢達 to recommend size, cannot scan toaccessLongToken login in the cloudzet.
    dafQrSettings() {
      return {
        text: `${window.location.origin}/?token=${this.accessLongToken}&scan=false`,
        size: 350,
        margin: 10,
      };
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-circle {
  @apply fixed left-0 right-0 mx-auto;
  top: 50%;
  transform: translateY(-50%);
  width: 80%;
  max-width: 700px;
}
.qr-stream-wrapper {
  @extend .loading-circle;
  max-width: 364px;
  max-height: 366px;
}

.qr-code-wrap {
  width: 200px;
  height: 200px;
  margin: auto;
  margin-bottom: 2rem;
}

::v-deep .qrcode-stream-camera {
  // NOTE: match the design of the one in native app
  border-radius: 19px;

  border: 4px solid transparent;
  background-image: linear-gradient(white, white),
    linear-gradient(90deg, #8146ff -2.22%, #4659ff 103.19%);
  background-origin: border-box;
  background-clip: content-box, border-box;

  --s: 60px; /* the size on the corner */
  mask: conic-gradient(at var(--s) var(--s), #0000 75%, #000 0) 0 0 / calc(100% - var(--s))
      calc(100% - var(--s)),
    linear-gradient(#000 0 0) content-box;
}

.open-qr-link {
  @extend .loading-circle;
  cursor: pointer;
  top: 85%;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    background: linear-gradient(to right, #2245ff 0%, #540deb 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .show-rq-icon {
    margin-right: 0.5rem;
  }
}

@media screen and (min-width: 576px) {
  .qr-code-wrap {
    width: 350px;
    height: 350px;

    img {
      width: 100%;
    }
  }
}
</style>
